import React, { Component } from 'react';
import { connect } from 'react-redux';
import AvaRIEInput from '../fields/input/AvaRIEInput';
import Collapsible from 'react-collapsible';
import AvaJsonTreeview from "../documentViewers/json/AvaJsonTreeview";
import deep from 'deep-diff';
import _ from 'underscore';

import InvoiceLine from './InvoiceLine';
import DocumentTotals from './DocumentTotals';
import BookingInfo from './BookingInfo';

import LANGUAGES_CONTROLLER from '../../controllers/languages';
import ERROR_DOCUMENT_DETAIL_CONTROLLER from '../../controllers/errorDocumentDetail';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import JSON_TRANSFORM from '../../utils/jsonTransform/jsonTransformers';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';


const FORM_NAME = 'ERROR_DOCUMENT_EDITOR_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

class ErrorDocumentDetailForm extends Component {

  constructor(props) {
    super(props);
    this.doReprocessErrorDocument = this.doReprocessErrorDocument.bind(this);
  }

  render() {
    log.debug('ErrorDocumentDetailForm render(): ', this.props);

    if (!this.props.formData || !this.props.formData.fieldValues) {
      return (<div>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_NoFields')}</div>);
    }

    if (_.isEmpty(this.props.errorDetail)) {
      return (
        <h2 className="text-center"><br /><span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_NoDetails')}</span></h2>
      );
    }

    const fieldValues = (this.props.formData && this.props.formData.fieldValues) || {};
    const jsonViewerValues = (this.props.formData && this.props.formData.structured) || {};
    const errorDetails = (this.props.errorDetail) || {};
    const fieldReferences = errorDetails.flatFieldMap || {};
    const currencies = errorDetails.currencies;
    const AdditionalDocDataTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_AdditionalDocData')}</span>;
    const AdditionalDocumentRefTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_AdditionalDocumentRef')}</span>;
    const DocumentIntrastatDataTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentIntrastatData')}</span>;
    const BookingInformationTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_BookingInformation')}</span>;
    const MiscTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Misc')}</span>;
    const FileDetailsTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_FileDetails')}</span>;
    const AllDataTrigger = <span><s-icon name="chevron-down"></s-icon> {LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_AllData')}</span>;

    return (
      <ReadOnlyWrapper>
        <div>
          <div className="invoice-container" data-testid="invoice-container">
            <h2>{fieldValues["errorMessage"]}</h2>
            <hr />
            <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceNumber')}:&nbsp;
              <AvaRIEInput
                propName="errorJson.ReportingDocument.InvoiceProperties.InvoiceNumber"
                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.InvoiceNumber"]}
                change={this.handleRIEFieldChange.bind(this)}
                classEditing="editing width-auto"
              />
              <span className="float-right mt4">
                <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceDate')}:&nbsp;</span>
                <AvaRIEInput
                  propName="errorJson.ReportingDocument.InvoiceProperties.InvoiceDate"
                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.InvoiceDate"]}
                  change={this.handleRIEFieldChange.bind(this)}
                  classEditing="editing width-auto"
                />
              </span>
              <div className="clear"></div>
            </h2>
            <hr />
            <div className="invoice-panel">
              <s-row>
                <s-col span="6">
                  {/* Top Left Panel - Supplier */}
                  <div className="details-panel">
                    <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Supplier')}</h2>
                    <table className="borderless">
                      <tbody>
                        <tr>
                          <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierId')}:</span></td>
                          <td className="half-width">
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierID"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierID"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierUserId')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.UserID"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.UserID"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierName')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.Name"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.Name"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Address')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.Address"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.Address"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_City')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.City"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.City"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Country')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.Country"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.Country"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ZIP')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.ZIP"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.ZIP"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_VATNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.VATNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.VATNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_VATNumberCountry')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.VATNumberCountry"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.VATNumberCountry"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_VATNumberType')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.VATNumberType"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.VATNumberType"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>

                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_TaxNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.TaxNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.TaxNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_TaxNumberCountry')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.TaxNumberCountry"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.VATNumber.TaxNumberCountry"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierIdentifierPassportNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.PassportNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.PassportNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierIdentifierIdCardNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.IdCardNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.IdCardNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierIdentifierResidencyCertificate')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.ResidencyCertificate"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierData.Identifier.ResidencyCertificate"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </s-col>
                <s-col span="6">
                  {/* Top Right Panel - Customer */}
                  <div className="details-panel">
                    <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Customer')}</h2>
                    <table className="borderless">
                      <tbody>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerId')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerID"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerID"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerUserId')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.UserID"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.UserID"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerName')}</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Name"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Name"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Address')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Address"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Address"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_City')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.City"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.City"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Country')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Country"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Country"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ZIP')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.ZIP"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.ZIP"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_VATNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_VATNumberCountry')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumberCountry"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumberCountry"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_VATNumberType')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumberType"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.VATNumberType"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_TaxNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.TaxNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.TaxNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_TaxNumberCountry')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.TaxNumberCountry"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.VATNumber.TaxNumberCountry"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerIdentifierPassportNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.PassportNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.PassportNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerIdentifierIdCardNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.IdCardNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.IdCardNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CustomerIdentifierResidencyCertificate')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.ResidencyCertificate"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CustomerData.Identifier.ResidencyCertificate"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </s-col>
              </s-row>
              {/* Document Details panel */}
              <div className="details-panel">
                <hr />
                <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentDetails')}</h2>
                <s-row>
                  <s-col span="6">
                    <table className="borderless">
                      <tbody>
                        <tr>
                          <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentCurrency')}:</span></td>
                          <td className="half-width">
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.DocumentCurrency"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.DocumentCurrency"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentType')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.DocumentType"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.DocumentType"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_PostingDate')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.IncomingPostingDate"
                                value={fieldValues["errorJson.ReportingDocument.IncomingPostingDate"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_TransactionDate')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.TransactionDate._"
                                value={fieldValues["errorJson.ReportingDocument.TransactionDate._"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CountryVATNumberUsedByCustomer')}: </span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CountryVATNumberUsedByCustomer"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CountryVATNumberUsedByCustomer"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CountryVATNumberUsedBySupplier')}: </span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.CountryVATNumberUsedBySupplier"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.CountryVATNumberUsedBySupplier"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </s-col>
                  <s-col span="6">
                    <table className="borderless">
                      <tbody>
                        <tr>
                          <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceNumber')}:</span></td>
                          <td className="half-width">
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.InvoiceNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.InvoiceNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_SupplierInvoiceNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.SupplierInvoiceNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.SupplierInvoiceNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ReferenceInvoiceNumber')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.ReferenceInvoiceNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.ReferenceInvoiceNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ReferenceInvoiceDate')}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.ReferenceInvoiceDate"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.ReferenceInvoiceDate"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </s-col>
                </s-row>
                {/* eInvoice Data Section */}
                <s-row>
                  <s-col span="12">
                    <hr className="mt15 mb15" />
                    <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_eInvoiceData') || 'EInvoice Data'}</h2>
                    <table className="borderless">
                      <tbody>
                        <tr>
                          <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_UniqueDocumentCode') || 'Unique Document Code'}:</span></td>
                          <td className="half-width">
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCode"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCode"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_UniqueDocumentCodeCountry') || 'Unique Document Code Country'}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCodeCountry"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCodeCountry"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_UniqueDocumentCodeType') || 'Unique Document Code Type'}:</span></td>
                          <td>
                            <span>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCodeType"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.eInvoiceData.UniqueDocumentCodeType"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </s-col>
                </s-row>
              </div>
            </div>

            {/* Document totals */}
            <hr />
            <h2 className="mb15">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_DocumentTotals')}</h2>
            <div className="invoice-lines">
              <table className="width-fit-content">
                <thead>
                  <tr>
                    <th><p className="text-align-center">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_ValueExclVAT')}</p></th>
                    <th><p className="text-align-center">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_TaxableBasis')}</p></th>
                    <th><p className="text-align-center">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines_VAT')}</p></th>
                  </tr>
                </thead>
                {
                  (() => {
                    if (!fieldReferences
                      || !fieldReferences.ReportingDocument
                      || !fieldReferences.ReportingDocument.InvoiceProperties
                      || fieldReferences.ReportingDocument.InvoiceProperties.InvoiceLines <= 0) {
                      return (<div>None</div>)
                    }
                    return fieldReferences.ReportingDocument.InvoiceProperties.InvoiceLines.map((refs, index) => {
                      return (
                        <DocumentTotals
                          fieldRefs={fieldReferences}
                          currencies={currencies}
                          lineIndex={index}
                          formData={this.props.formData.fieldValues}
                          change={this.handleRIEFieldChange.bind(this)}
                        />
                      )
                    })
                  })()
                }
              </table>
            </div>

            {/* Invoice Lines */}
            <h2 className="mb15">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InvoiceLines')}</h2>
            {
              (() => {
                if (!fieldReferences
                  || !fieldReferences.ReportingDocument
                  || !fieldReferences.ReportingDocument.InvoiceProperties
                  || fieldReferences.ReportingDocument.InvoiceProperties.InvoiceLines <= 0) {
                  return (<div>None</div>)
                }
                return fieldReferences.ReportingDocument.InvoiceProperties.InvoiceLines.map((refs, index) => {
                  return (
                    <InvoiceLine
                      fieldRefs={refs}
                      currencies={currencies}
                      key={index}
                      formData={this.props.formData.fieldValues}
                      change={this.handleRIEFieldChange.bind(this)}
                    />
                  )
                })
              })()
            }

            {/* Additional document data */}
            <div className="toggle-container min-height-none mb15">
              <Collapsible trigger={AdditionalDocDataTrigger}>
                <s-container>
                  <div className="flex-box-container relative z-index-1">
                    <div className="clear"></div>
                    {/* Additional Document Reference */}
                    <Collapsible trigger={AdditionalDocumentRefTrigger}>
                      <table className="borderless">
                        <tbody>
                          <tr>
                            <td className={withFullStoryExclude("half-width")}><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentAmount')}</span></td>
                            <td className={withFullStoryExclude("half-width")}>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentAmount"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentAmount"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentCurrency')}</span></td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentCurrency"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentCurrency"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentDate')}</span></td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentDate"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentDate"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentNumber')}</span></td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentNumber"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentNumber"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ClearingDocumentPaymentMethod')}</span></td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentPayementMethod"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ClearingDocumentPayementMethod"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ReferenceType')}</span></td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ReferenceType"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AdditionalDocumentReference.$.ReferenceType"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Collapsible>
                    {/* Document Intrastat Data */}
                    <Collapsible trigger={DocumentIntrastatDataTrigger}>

                      <table className="borderless">
                        <tbody>
                          <tr>
                            <td className="half-width"><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_TransactionType')}</span></td>
                            <td className="half-width">
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.TransactionType"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.TransactionType"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_AdditionalTransactionType')}</span></td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.AdditionalTransactionType"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.AdditionalTransactionType"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CountryArrival')}</span></td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.CountryArrival"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.CountryArrival"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_CountryDispatch')}</span></td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.CountryDispatch"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.CountryDispatch"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_IntrastatDocumentData_VATNumberCustomer')}</span></td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.VATNumberCustomer"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.VATNumberCustomer"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td><span className="mt0 uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_IntrastatDocumentData_VATNumberSupplier')}</span>
                            </td>
                            <td>
                              <span>
                                <AvaRIEInput
                                  propName="errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.VATNumberSupplier"
                                  value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.IntrastatDocumentData.VATNumberSupplier"]}
                                  change={this.handleRIEFieldChange.bind(this)}
                                />
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Collapsible>
                    {/* Booking Information */}
                    <Collapsible trigger={BookingInformationTrigger}>
                      <table className="borderless">
                        <thead>
                          <tr>
                            <th><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_BookingInfo_AccountNumber')}</span></th>
                            <th><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_BookingInfo_Amount')}</span></th>
                            <th><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_BookingInfo_Currency')}</span></th>
                            <th><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_BookingInfo_VATCode')}</span></th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            (() => {
                              if (!fieldReferences
                                || !fieldReferences.ReportingDocument
                                || !fieldReferences.ReportingDocument.InvoiceProperties
                                || fieldReferences.ReportingDocument.InvoiceProperties.BookingInformation <= 0) {
                                return (<div>None</div>)
                              }
                              return fieldReferences.ReportingDocument.InvoiceProperties.BookingInformation.map((refs, index) => {
                                return (
                                  <BookingInfo
                                    fieldRefs={refs}
                                    key={index}
                                    formData={this.props.formData.fieldValues}
                                    change={this.handleRIEFieldChange.bind(this)}

                                  />
                                )
                              })
                            })()
                          }
                        </tbody>
                      </table>
                    </Collapsible>
                    {/* Other */}
                    <Collapsible trigger={MiscTrigger}>
                      <table className="borderless">
                        <tbody>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_AutofatturraNumber')}</span></td>
                            <td>
                              <AvaRIEInput
                                propName="errorJson.ReportingDocument.InvoiceProperties.AutoFatturaNumber"
                                value={fieldValues["errorJson.ReportingDocument.InvoiceProperties.AutoFatturaNumber"]}
                                change={this.handleRIEFieldChange.bind(this)}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Collapsible>
                    {/* Error File Details - not editable */}
                    <Collapsible trigger={FileDetailsTrigger}>
                      <table className="borderless">
                        <tbody>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_InFile')}</span></td>
                            <td>{fieldValues["documentName"]}</td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ErrorId')}</span></td>
                            <td>{fieldValues["id"]}</td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ErrorPath')}</span></td>
                            <td>{fieldValues["errorPath"]}</td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ErrorTag')}</span></td>
                            <td>{fieldValues["tagName"]}</td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ErrorTagValue')}</span></td>
                            <td>{fieldValues["tagValue"]}</td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ConnectorName')}</span></td>
                            <td>{fieldValues["errorJson.ReportingDocument.ConnectorName"]}</td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ConnectorVersion')}</span></td>
                            <td>{fieldValues["errorJson.ReportingDocument.ConnectorVersion"]}</td>
                          </tr>
                          <tr>
                            <td><span className="uppercase">{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_ErrorUUID')}</span></td>
                            <td>{fieldValues["errorJson.ReportingDocument.IVATUUID"]}</td>
                          </tr>
                        </tbody>
                      </table>
                    </Collapsible>
                  </div>
                </s-container>
              </Collapsible>
              {/* JSON Viewer for _full_ document */}
              <Collapsible trigger={AllDataTrigger}>

                <AvaJsonTreeview
                  src={
                    jsonViewerValues
                    && jsonViewerValues.errorJson
                    && jsonViewerValues.errorJson.ReportingDocument}
                  collapsed={true}
                  onEdit={
                    e => { this.handleJsonViewerChange(e) }
                  }
                />

              </Collapsible>
            </div>
          </div>
          {
            this.props.formData.changed ? (
              <div>
                <button className="primary mt15" onClick={this.onSubmitForm.bind(this)}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Submit')}</button>
                <button className="sedonary mt15" onClick={this.onResetForm.bind(this)}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'errorDocumentDetail_Reset')}</button>
              </div>
            ) : (<div></div>)}
        </div>
      </ReadOnlyWrapper>

    );
  }

  componentWillUnmount() {
    log.debug('componentWillUnMount: ', FORM_NAME);
    this.props.doDestroyForm(FORM_NAME);
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.props.doInitialiseForm(this.props.errorDetail);
    this.props.doAddStructuredObject(this.props.errorDetail);
  }

  handleRIEFieldChange(data) {
    for (const [key, value] of Object.entries(data)) {
      log.debug('handleRIEFieldChange :', key, value);
      this.doFieldChange(key, value);
    }
  }

  handleJsonViewerChange(data) {
    log.debug('handleJsonViewerChange: ', data);

    const diff = deep(data.existing_src, data.updated_src);
    let value = diff[0].rhs;
    let key = 'errorJson.ReportingDocument.';
    key += JSON_TRANSFORM.arrayToFlatReference(diff[0].path);

    // SVR-840 Make values not editable in treeview to match main ux
    // the change is reset back to the old value 'lhs' before doing the update
    // list can be extended if needed
    if (_.contains(['IVATUUID', 'ConnectorVersion', 'ConnectorName'], data.name)) {
      value = diff[0].lhs;
    }

    this.doFieldChange(key, value);

  }

  doFieldChange(key, value) {
    log.debug('doFieldChange: key: %s value: ', key, value);
    this.props.onFieldChange(key, value);
    this.props.onStructuredFieldChange(key, value);
  }

  doReprocessErrorDocument(formData, callback) {
    // We have all the info we need here in formData to create the replaceTagVagValue
    log.debug('doReprocessError Page: formData: ', formData);

    // Send reference to the formData to the controller to work out what changed
    this.props.doReprocessError(formData, callback);
  }

  onSubmitForm() {
    log.debug('onSubmitForm(): ', this.props.formData);
    // use the handler passed in from the page and pass it this formData
    this.doReprocessErrorDocument(this.props.formData, this.props.onProcessed);
    if (typeof this.props.submitHandler === 'function') {
      this.props.submitHandler(this.props.formData);
    }
    // Let the forms controller know that the form has been submitted.
    this.props.doFormSubmitted(FORM_NAME);
  }

  onResetForm() {
    log.debug('onResetForm(): ');
    this.props.doResetForm(FORM_NAME);
    this.props.doAddStructuredObject(this.props.errorDetail);
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state);
  log.debug('mapStateToProps(): props', props);

  return {
    // Almost all components will need to use language strings, so add them to the props from the global state
    languages: state.languages,
    formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME]),

    // TODO: Add additional data we want to extract from the global state and inject into the props here
  };
}


ErrorDocumentDetailForm.defaultProps = {
  onProcessed: () => { },
  id: '',
  errorDetail: {}
}

function mapDispatchersToProps(dispatch) {
  return {
    // Standard form actions
    doInitialiseForm: (initialValues) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, JSON_TRANSFORM.flattenJSON(initialValues)));
    },
    doAddStructuredObject: (structured) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doAddStructuredObject(FORM_NAME, structured));
    },
    doResetForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
    },
    doClearForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
    },
    onFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
    },
    onStructuredFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doStructuredFieldChange(FORM_NAME, fieldName, value));
    },
    doFormSubmitted: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
    },
    doDestroyForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(FORM_NAME));
    },
    //TODO: Add dispatchers (actions we expect controllers to perform) here.
    doReprocessError: (formData, callback = () => { }) => {
      dispatch(ERROR_DOCUMENT_DETAIL_CONTROLLER.doReprocessError(formData, callback));
    }
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(ErrorDocumentDetailForm);
